import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditDotIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse 
        cx="8" cy="8.5" rx="8" ry="8.5" 
        fill={props.fillColor ?? "black"}
      />
    </svg>
  );
}

export default EditDotIcon;